@if (_isOpen()) {
    <div>
        <div class="grid-container p-24:b md:p-32:b lg:p-48:b">
            <!-- #region deductible toggle -->
            <div class="g-12 grid-container -equal-h m-32:b md:m-48:b">
                <app-variants-fieldset
                    [hasDeductible]="hasDeductible()"
                    [hasMonthlySettlementPeriod]="hasMonthlySettlementPeriod()"
                    [hasTheftCoverage]="hasTheftCoverage()"
                    (toggleDeductible)="toggleDeductible($event)"
                    (toggleSettlementPeriod)="toggleSettlementPeriod($event)"
                    (toggleTheftCoverage)="toggleTheftCoverage($event)"
                    [compactMode]="true"
                />
            </div>
            <!-- #endregion -->
            <div class="g-12">
                <p>Bitte mache weitere Angaben zum versicherten Gerät.</p>
            </div>
        </div>
        <form
            [formGroup]="form"
            (submit)="submit()"
        >
            <div
                class="grid-container"
                formGroupName="device"
            >
                <!-- #region main device form -->
                <!-- #region optional device type -->
                @if (!hideTypeSelector()) {
                    <div class="g-12 form-control">
                        <label
                            for="type"
                            formControlName="type"
                            appReactiveLabel
                            >Gerätetyp*:</label
                        >
                        <select
                            formControlName="type"
                            required
                        >
                            <option
                                [value]="null"
                                disabled
                            >
                                {{ 'Gerätetyp' | formLabel: true : 'select' }}
                            </option>
                            @for (device of devices; track device.name) {
                                <option [value]="device.displayName">
                                    {{ device.displayName }}
                                </option>
                            }
                        </select>
                    </div>
                }
                <!-- #endregion -->
                <div class="g-12 form-control">
                    <label
                        formControlName="description"
                        appReactiveLabel
                    >
                        {{ (isAppliance() ? 'Gerätetyp 2' : 'Hersteller') | formLabel }}:
                    </label>

                    <app-select-with-other-option
                        [options]="manufacturers()"
                        formControlName="description"
                        [placeholder]="(isAppliance() ? 'Gerätetyp 2' : 'Hersteller') | formLabel: true : 'select'"
                        [errorMessages]="descriptionErrorMessage()"
                        [pleaseEnterOtherLabel]="
                            isAppliance() ? 'Bitte gib den Gerätetyp an*' : 'Bitte gib den Hersteller an*'
                        "
                    />
                </div>
                <div class="g-12 form-control">
                    @let model = form.controls.device.controls.model;
                    <label
                        for="device-model"
                        formControlName="model"
                        appReactiveLabel
                        >{{ (isAppliance() ? 'Marke' : 'Modell und Speicherkapazität') | formLabel }}:</label
                    >
                    <input
                        id="device-model"
                        type="text"
                        [placeholder]="(isAppliance() ? 'Marke' : 'Modell und Speicherkapazität') | formLabel"
                        formControlName="model"
                        [attr.aria-invalid]="model.touched && model.invalid"
                        [attr.aria-errormessage]="deviceModelErrorId"
                        required
                    />
                    <app-error-messages
                        formControlName="model"
                        [id]="deviceModelErrorId"
                        [messages]="isAppliance() ? 'Bitte gib die Marke an.' : 'Bitte gib das Gerätemodell an.'"
                    />
                </div>
                <div class="g-12 form-control with-info-tooltip">
                    @let deviceValue = form.controls.device.controls.value;
                    <label
                        for="device-value"
                        formControlName="value"
                        appReactiveLabel
                        >Unsubventionierter Kaufpreis*:</label
                    >
                    <input
                        type="text"
                        appPriceInput
                        outputType="string"
                        id="device-value"
                        placeholder="Unsubventionierter Kaufpreis*"
                        formControlName="value"
                        [attr.aria-invalid]="deviceValue.touched && deviceValue.invalid"
                        [attr.aria-errormessage]="deviceValueErrorId"
                        required
                    />
                    <app-info-tooltip
                        heading="Unsubventionierter Kaufpreis"
                        text="Der unsubventionierte Kaufpreis ist der zum Kaufzeitpunkt gültige
                            Marktpreis. Wenn das Gerät z.B. im Rahmen eines Mobil&shy;funkvertrags
                            oder gebraucht erworben wurde, gib bitte den tatsächlichen Neuwert des
                            Gerätes zum Zeitpunkt des Kaufs an."
                    />
                    <app-error-messages
                        formControlName="value"
                        [id]="deviceValueErrorId"
                        [messages]="valueErrorMessages"
                    />
                </div>
                <div class="g-12 form-control">
                    @let date = form.controls.device.controls.date;
                    <label
                        formControlName="date"
                        appReactiveLabel
                        for="date-of-purchase-input"
                        >{{ 'Kaufdatum' | formLabel: true : 'date' }}:</label
                    >
                    <input
                        id="date-of-purchase-input"
                        type="text"
                        ctrlDateInput
                        [placeholder]="'Kaufdatum' | formLabel: true : 'date'"
                        formControlName="date"
                        [attr.aria-invalid]="date.touched && date.invalid"
                        [attr.aria-errormessage]="dateErrorId"
                        required
                    />
                    <app-error-messages
                        formControlName="date"
                        [id]="dateErrorId"
                        [messages]="dateErrorMessages"
                    />
                </div>
                <div
                    class="g-12 form-control"
                    [ngClass]="{ 'with-info-tooltip': serial === 'IMEI' }"
                >
                    @let detail = form.controls.device.controls.detail;
                    <label
                        for="serial-number"
                        formControlName="detail"
                        appReactiveLabel
                        >{{ serial | formLabel: false }}:</label
                    >
                    <input
                        type="text"
                        id="serial-number"
                        formControlName="detail"
                        [attr.aria-invalid]="detail.touched && detail.invalid"
                        [attr.aria-errormessage]="detailErrorId"
                        [placeholder]="serial | formLabel: false"
                    />
                    @if (serial === 'IMEI') {
                        <app-info-tooltip
                            text="Die IMEI ist eine eindeutige Seriennummer, mit welcher jedes Gerät identifiziert werden kann.
                Die IMEI kann durch die Eingabe *#06# im Eingabefeld der Telefonnummer abgefragt werden."
                        />
                    }
                    <app-error-messages
                        formControlName="detail"
                        [id]="detailErrorId"
                        [messages]="detailErrorMessages"
                    />
                </div>
                <div class="g-12 m-12:b md:m-16:b lg:m-24:b">
                    <small>
                        <strong>Hinweis:</strong> Du kannst die {{ serial }} nach Abschluss im Kundenportal ergänzen.
                        Der Versicherungsschutz besteht erst nach Ergänzung.
                    </small>
                </div>
                <!-- #endregion -->
            </div>

            <!-- #region toggle lens -->
            @if (deviceType() === 'Kamera') {
                <div class="grid-container m-24:v md:m-32:v lg:m-48:v">
                    <div class="g-12">
                        <h4>Möchtest du zusätzlich zur Kamera ein Objektiv versichern?</h4>
                    </div>
                    <div class="g-12">
                        <input
                            type="checkbox"
                            id="toggle-lens"
                            formControlName="toggleLens"
                        />
                        <label for="toggle-lens"> Ja, ich möchte ein Objektiv mitversichern. </label>
                    </div>
                </div>
            }
            <!-- #endregion -->

            <!-- #region camera lens -->
            @if (showLensForm()) {
                <div
                    class="grid-container"
                    formGroupName="lens"
                >
                    <div class="g-12 form-control">
                        <label
                            formControlName="description"
                            appReactiveLabel
                            >Hersteller*:</label
                        >
                        <app-select-with-other-option
                            [options]="lensManufacturers"
                            formControlName="description"
                            [placeholder]="'Hersteller' | formLabel: true : 'select'"
                            [errorMessages]="descriptionErrorMessage()"
                        />
                    </div>
                    <div class="g-12 form-control">
                        @let lensModel = form.controls.lens.controls.model;
                        <label
                            for="lens-model"
                            formControlName="model"
                            appReactiveLabel
                            >Modell*:</label
                        >
                        <input
                            id="lens-model"
                            type="text"
                            placeholder="Modell*"
                            formControlName="model"
                            [attr.aria-invalid]="lensModel.touched && lensModel.invalid"
                            [attr.aria-errormessage]="lensModelErrorId"
                            required
                        />
                        <app-error-messages
                            formControlName="model"
                            [id]="lensModelErrorId"
                            [messages]="lensModelErrorMessages"
                        />
                    </div>
                    <div class="g-12 form-control with-info-tooltip">
                        @let lensValue = form.controls.lens.controls.value;
                        <label
                            for="lens-value"
                            formControlName="value"
                            appReactiveLabel
                            >Kaufpreis*:</label
                        >
                        <input
                            type="text"
                            appPriceInput
                            outputType="string"
                            id="lens-value"
                            placeholder="Kaufpreis*"
                            formControlName="value"
                            [attr.aria-invalid]="lensValue.touched && lensValue.invalid"
                            [attr.aria-errormessage]="lensValueErrorId"
                            required
                        />
                        <app-info-tooltip
                            heading="Unsubventionierter Kaufpreis"
                            text="Der unsubventionierte Kaufpreis ist der zum Kaufzeitpunkt gültige
                            Marktpreis. Wenn das Gerät z.B. im Rahmen eines Mobil&shy;funkvertrags
                            oder gebraucht erworben wurde, gib bitte den tatsächlichen Wert
                            des Gerätes zum Zeitpunkt des Kaufs an."
                        />
                        <app-error-messages
                            formControlName="value"
                            [id]="lensValueErrorId"
                            [messages]="valueErrorMessages"
                        />
                    </div>
                    <div class="g-12 form-control">
                        <label
                            for="serial-number"
                            formControlName="detail"
                            appReactiveLabel
                            >Seriennummer:</label
                        >
                        <input
                            type="text"
                            id="serial-number"
                            formControlName="detail"
                            placeholder="Seriennummer"
                        />
                    </div>
                </div>
            }
            <app-required-info />
            <!-- #endregion -->

            <!-- #region price display -->
            <app-inline-price-display
                [price]="price()"
                [settlementPeriod]="hasMonthlySettlementPeriod() ? 'month' : 'year'"
                [taxInfo]="product().orderConfig.taxInfo"
            />
            <!-- #endregion -->

            <!-- #region controls -->
            <app-navigation-buttons
                [nextDisabled]="form.invalid"
                [showBack]="isFirstStep"
                (prev)="btnPrev()"
                (next)="submit()"
                nextTooltip="Bitte gib alle erforderlichen Gerätedaten an"
            />
            <!-- #endregion -->
        </form>
    </div>
}
